import { render, staticRenderFns } from "./MyLeadsList.vue?vue&type=template&id=5abdd97d&scoped=true&"
import script from "./MyLeadsList.vue?vue&type=script&lang=js&"
export * from "./MyLeadsList.vue?vue&type=script&lang=js&"
import style0 from "./MyLeadsList.vue?vue&type=style&index=0&id=5abdd97d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abdd97d",
  null
  
)

export default component.exports